<app-modal-template [title]="'Downloads' | translate" [hasCloseButton]="true" [size]="PencilModalSizeEnum.MEDIUM"
    (closeButtonClicked)="handleClose($event)">
    <div class="portal-file-manager" content-description>
        <ng-container *ngIf="{ loading: loading$ | async, files: files$ | async } as state">
            <div class="portal-file-manager__header">
                <app-pencil-button [theme]="PencilButtonThemeEnum.SECONDARY" icon="refresh"
                    [iconConfig]="{ type: IconTypes.materialIcon }" [showSpinner]="state.loading"
                    [disabled]="state.loading" (clickEvent)="refreshFiles()">
                    {{ 'Refresh' | translate }}
                </app-pencil-button>
            </div>

            <div class="portal-file-manager__content">
                <app-pencil-spinner *ngIf="state.loading" [diameter]="32" [strokeWidth]="3"
                    class="portal-file-manager__spinner"></app-pencil-spinner>

                <div *ngIf="!state.loading && (state.files?.length === 0)" class="portal-file-manager__empty">
                    {{ 'No files available' | translate }}
                </div>

                <div *ngIf="!state.loading && (state.files?.length ?? 0) > 0" class="portal-file-manager__file-list">
                    <div *ngFor="let file of state.files; trackBy: trackByFileName"
                        class="portal-file-manager__file-item">
                        <div class="portal-file-manager__file-name">{{ file.name }}</div>
                        <div class="portal-file-manager__file-size">{{ file.size | formatBytes }}</div>
                        <app-pencil-button [theme]="PencilButtonThemeEnum.ICON" [icon]="'file_download'"
                            [iconConfig]="{ type: IconTypes.materialIcon }" [showSpinner]="file.isDownloading ?? false"
                            [disabled]="file.isDownloading ?? false" (clickEvent)="downloadFile(file)">
                        </app-pencil-button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</app-modal-template>
